import { render, staticRenderFns } from "./categoriesT3.vue?vue&type=template&id=4acb6e9e"
import script from "./categoriesT3.vue?vue&type=script&lang=js"
export * from "./categoriesT3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports